<section class="page-title-area">
    <div class="card-header">
        <div class="card-title" style="width: 70vw">
            <h3 class="card-label">Kepler Data Ingestion Request Form</h3>
            <p>
                This form is to be used by Upstream customers when needing to
                import data into Kepler from one or multiple data sources. Prior
                to placing a request for new data to be ingested, check if data
                is currently available: Kepler -> Data Explorer -> Ingestion. If
                data is currently not in Kepler, a new request is needed. For
                third party data, contact the 3rd Party Data Office by going to
                <a href="https://goto/getdata" target="_blank">goto/getdata</a>.
            </p>
            <p>
                Once submitted, the request is routed to the appropriate support
                team for approval and implementation. The requestor or key
                business representative will be contacted if additional
                information is required. For assistance in completing this form
                or questions regarding the status of the submission please
                contact the
                <a href="mailto:UDGP-UDFSupport@exxonmobil.com" target="_top"
                    >UDFO support team</a
                >(UDGP-UDFSupport&#64;exxonmobil.com).
            </p>
            <p><span class="required">*</span> Required fields</p>
        </div>
    </div>
    <div class="card-body" style="width: 90vw">
        <!--begin: Wizard -->
        <div
            #wizard
            class="wizard wizard-3"
            id="kt_wizard_v3"
            data-wizard-state="step-first"
        >
            <div class="kt-grid__item">
                <!--begin: Form Wizard Nav -->
                <div class="wizard-nav border-bottom mb-1 mb-lg-5">
                    <div class="wizard-steps px-8 py-8 px-lg-15 py-lg-3">
                        <ng-container
                            *ngFor="let item of formUses; let i = index"
                        >
                            <ng-container *ngIf="item.visible">
                                <a
                                    class="wizard-step"
                                    href="javascript:;"
                                    data-wizard-type="step"
                                >
                                    <div class="wizard-label">
                                        <div class="wizard-title">
                                            {{ item.title }}
                                        </div>
                                        <div class="wizard-bar"></div>
                                    </div>
                                </a>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
                <!--end: Form Wizard Nav -->
                <div
                    class="row justify-content-center py-12 px-8 py-lg-15 px-lg-10"
                >
                    <div class="col-lg-10 col-xl-8 col-xxl-7">
                        <!--begin: Form Wizard Form-->
                        <form
                            #formElemRef
                            #form="ngForm"
                            class="form"
                            id="kt_form"
                            (ngSubmit)="submit()"
                            [formGroup]="workflowForm"
                        >
                            <ng-template
                                #recursiveList
                                let-formUses
                                let-formGroup="formGroup"
                            >
                                <ng-container *ngFor="let item of formUses">
                                    <ng-container
                                        *ngIf="item.group; else default"
                                    >
                                        <ng-container *ngIf="item.visible">
                                            <div
                                                class="pb-5"
                                                data-wizard-type="step-content"
                                            >
                                                <div
                                                    class=""
                                                    [formGroupName]="item.id"
                                                >
                                                    <ng-container
                                                        *ngTemplateOutlet="
                                                            recursiveList;
                                                            context: {
                                                                $implicit:
                                                                    item.group,
                                                                formGroup: {
                                                                    name: item.id
                                                                }
                                                            }
                                                        "
                                                    >
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </ng-container>

                                    <ng-template #default>
                                        <div [formGroupName]="formGroup.name">
                                            <mat-form-field
                                                *ngIf="
                                                    item.type.type == 'text' ||
                                                    item.type.type ===
                                                        'textarea' ||
                                                    item.type.type === 'select'
                                                "
                                                [matTooltip]="item.tooltip"
                                                matTooltipClass="tooltip"
                                                matTooltipPosition="right"
                                            >
                                                <mat-label
                                                    >{{ item.label
                                                    }}<span
                                                        *ngIf="isRequired(item)"
                                                        class="required"
                                                        >*</span
                                                    ></mat-label
                                                >
                                                <input
                                                    matInput
                                                    [maxlength]="item.type.maxLength"
                                                    *ngIf="
                                                        item.type.type ===
                                                        'text'
                                                    "
                                                    [type]="item.type.type"
                                                    [formControlName]="item.id"
                                                    [name]="item.id"
                                                />

                                                <mat-select
                                                    *ngIf="
                                                        item.type.type ===
                                                        'select'
                                                    "
                                                    formControlName="{{
                                                        item.id
                                                    }}"
                                                >
                                                    <mat-option
                                                        *ngFor="
                                                            let opt of item.type
                                                                .options
                                                        "
                                                        [value]="
                                                            opt.value
                                                                ? opt.value
                                                                : opt
                                                        "
                                                    >
                                                        {{
                                                            opt.name
                                                                ? opt.name
                                                                : opt
                                                        }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>

                                            <mat-form-field
                                                *ngIf="
                                                    item.type.type === 'date'
                                                "
                                                [matTooltip]="item.tooltip"
                                                matTooltipClass="tooltip"
                                                matTooltipPosition="right"
                                            >
                                                <mat-label
                                                    >{{ item.label
                                                    }}<span
                                                        *ngIf="isRequired(item)"
                                                        class="required"
                                                        >*</span
                                                    ></mat-label
                                                >
                                                <input
                                                    matInput
                                                    [matDatepicker]="picker"
                                                    [formControlName]="item.id"
                                                    [name]="item.id"
                                                />
                                                <mat-datepicker-toggle
                                                    matSuffix
                                                    [for]="picker"
                                                >
                                                </mat-datepicker-toggle>
                                                <mat-datepicker
                                                    #picker
                                                ></mat-datepicker>
                                            </mat-form-field>

                                            <people-picker
                                                *ngIf="
                                                    item.type.type ===
                                                    'people-picker'
                                                "
                                                #approverContact
                                                [TagControl]="
                                                    workflowForm.controls[
                                                        formGroup.name
                                                    ].get(item.id)
                                                "
                                                [Label]="item.label"
                                                [Multi]="item.multi"
                                                [matTooltip]="item.tooltip"
                                                [Required]="isRequired(item)"
                                                matTooltipClass="tooltip"
                                                matTooltipPosition="right"
                                            >
                                            </people-picker>

                                            <ad-group-picker
                                                *ngIf="
                                                    item.type.type ===
                                                    'ad-group-picker'
                                                "
                                                #adGroup
                                                [TagControl]="
                                                    workflowForm.controls[
                                                        formGroup.name
                                                    ].get(item.id)
                                                "
                                                [Label]="item.label"
                                                [matTooltip]="item.tooltip"
                                                matTooltipClass="tooltip"
                                                matTooltipPosition="right"
                                            >
                                            </ad-group-picker>

                                            <tagger
                                                *ngIf="
                                                    item.type.type === 'tagger'
                                                "
                                                #{{tag.formControlName}}
                                                [TagControl]="
                                                    workflowForm.controls[
                                                        formGroup.name
                                                    ].get(item.id)
                                                "
                                                [OtherTagControl]="
                                                    workflowForm.controls[
                                                        formGroup.name
                                                    ].get(item.id + 'Other')
                                                "
                                                [Tags]="item.type.tags"
                                                [Label]="item.label"
                                                [Multi]="item.type.multi"
                                                [Required]="isRequired(item)"
                                                [matTooltip]="item.tooltip"
                                                matTooltipClass="tooltip"
                                                matTooltipPosition="right"
                                            >
                                            </tagger>

                                            <mat-checkbox
                                                *ngIf="
                                                    item.type.type === 'boolean'
                                                "
                                                [formControlName]="item.id"
                                                [matTooltip]="item.tooltip"
                                                matTooltipShowDelay="1000"
                                                matTooltipPosition="right"
                                            >
                                                <span
                                                    id="content"
                                                    [innerHtml]="item.label"
                                                ></span>
                                            </mat-checkbox>

                                            <div
                                                *ngIf="
                                                    item.type.type ===
                                                    'custom-select'
                                                "
                                            >
                                                <mat-form-field
                                                    [matTooltip]="item.tooltip"
                                                    matTooltipPosition="right"
                                                    matTooltipClass="tooltip"
                                                >
                                                    <mat-label
                                                        >{{ item.label
                                                        }}<span
                                                            *ngIf="
                                                                isRequired(item)
                                                            "
                                                            class="required"
                                                            >*</span
                                                        ></mat-label
                                                    >

                                                    <mat-select
                                                        formControlName="{{
                                                            item.id
                                                        }}"
                                                    >
                                                        <mat-option
                                                            *ngFor="
                                                                let opt of item
                                                                    .type
                                                                    .options
                                                            "
                                                            [value]="
                                                                opt.name
                                                                    ? opt.name
                                                                    : opt
                                                            "
                                                        >
                                                            {{
                                                                opt.name
                                                                    ? opt.name
                                                                    : opt
                                                            }}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>

                                                <ng-container
                                                    *ngIf="
                                                        isCustomOptionSelected(
                                                            workflowForm.controls[
                                                                formGroup.name
                                                            ].get(item.id)
                                                                .value,
                                                            item
                                                        )
                                                    "
                                                >
                                                    <p
                                                        style="
                                                            padding-left: 16px;
                                                        "
                                                        [innerHtml]="
                                                            item.altHtmlContent
                                                        "
                                                    ></p>

                                                    <ng-container
                                                        *ngFor="
                                                            let option of item.customOptions
                                                        "
                                                    >
                                                        <mat-form-field
                                                            *ngIf="
                                                                option.value ==
                                                                workflowForm.controls[
                                                                    formGroup
                                                                        .name
                                                                ].get(item.id)
                                                                    .value
                                                            "
                                                            [matTooltip]="
                                                                option.tooltip
                                                            "
                                                            matTooltipPosition="right"
                                                            matTooltipClass="tooltip"
                                                            [ngClass]="
                                                                'other-tag'
                                                            "
                                                        >
                                                            <mat-label
                                                                >{{
                                                                    option.label
                                                                }}<span
                                                                    *ngIf="
                                                                        isRequired(
                                                                            item
                                                                        )
                                                                    "
                                                                    class="required"
                                                                    >*</span
                                                                ></mat-label
                                                            >

                                                            <input
                                                                *ngIf="
                                                                    option.type ==
                                                                    'text'
                                                                "
                                                                matInput
                                                                [type]="'text'"
                                                                [formControlName]="
                                                                    item.id +
                                                                    option.id
                                                                "
                                                                [name]="
                                                                    item.id +
                                                                    option.id
                                                                "
                                                            />
                                                        </mat-form-field>
                                                    </ng-container>
                                                </ng-container>
                                            </div>

                                            <div
                                                *ngIf="
                                                    item.type.type ===
                                                    'custom-list'
                                                "
                                            >
                                                <p
                                                    *ngIf="
                                                        isIngestionTypeSelected() &&
                                                        !workflowForm.valid
                                                    "
                                                >
                                                    <span class="required"
                                                        >*</span
                                                    >
                                                    Required fields must be
                                                    filled.
                                                </p>
                                                <ul
                                                    *ngFor="
                                                        let item of selections
                                                    "
                                                >
                                                    <p>{{ item.title }}</p>
                                                    <ng-container
                                                        [ngTemplateOutlet]="
                                                            ngReviewSelectionsTemplate
                                                        "
                                                        [ngTemplateOutletContext]="{
                                                            items: item.subItems
                                                        }"
                                                    >
                                                    </ng-container>
                                                </ul>
                                            </div>

                                            <p
                                                style="padding-left: 16px"
                                                [innerHtml]="item.htmlContent"
                                            ></p>
                                        </div>
                                    </ng-template>
                                </ng-container>
                            </ng-template>

                            <ng-container
                                *ngTemplateOutlet="
                                    recursiveList;
                                    context: { $implicit: formUses }
                                "
                            >
                            </ng-container>

                            <!--begin: Form Actions -->
                            <div
                                class="d-flex justify-content-between border-top pt-10"
                            >
                                <div class="mr-2">
                                    <div
                                        class="btn btn-light-primary font-weight-bold text-uppercase mt-2"
                                        data-wizard-type="action-prev"
                                    >
                                        Previous
                                    </div>
                                </div>
                                <div>
                                    <button
                                        (click)="hiddenSubmit()"
                                        type="submit"
                                        class="btn btn-primary font-weight-bold text-uppercase mt-2 {{
                                            workflowForm.valid
                                                ? 'valid'
                                                : 'invalid'
                                        }}"
                                        data-wizard-type="action-submit"
                                    >
                                        Submit
                                    </button>
                                    <button
                                        id="wizard-submit"
                                        hidden
                                        type="submit"
                                        color="primary"
                                        mat-flat-button
                                    >
                                        Submit
                                    </button>
                                    <div
                                        class="btn btn-primary font-weight-bold text-uppercase mt-2"
                                        data-wizard-type="action-next"
                                        (click)="scrollTop()"
                                    >
                                        Next Step
                                    </div>
                                </div>
                            </div>
                            <!--end: Form Actions -->
                        </form>
                        <!--end: Form Wizard Form-->
                    </div>
                </div>
            </div>
        </div>
        <!--end: Wizard -->

        <ng-template #submissionDialog let-data>
            <h1 mat-dialog-title class="header-div">Submitted Success</h1>

            <mat-dialog-content [innerHTML]="data"> </mat-dialog-content>

            <div class="mt-5">
                <button
                    color="primary"
                    mat-flat-button
                    (click)="submissionDialogRef.close()"
                >
                    Close
                </button>
            </div>
        </ng-template>

        <ng-template #customSelectTemplate let-item="item">
            <mat-form-field
                [matTooltip]="item.tooltip"
                matTooltipPosition="right"
            >
                <mat-label>{{ item.label }}</mat-label>

                <mat-select formControlName="{{ item.id }}">
                    <mat-option
                        *ngFor="let opt of item.type.options"
                        [value]="opt.value ? opt.value : opt"
                    >
                        {{ opt.name ? opt.name : opt }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-template>

        <ng-template #ngReviewSelectionsTemplate let-data="items">
            <div>
                <ul *ngFor="let item of data">
                    <li>
                        <span>
                            {{ item.label }}:
                            <span
                                *ngIf="!item.formControlStatus"
                                class="required"
                                >*</span
                            >
                            <span
                                *ngIf="item.formControlErrors"
                                class="required"
                                >Invalid Value</span
                            >
                        </span>
                        <span class="text-muted">
                            {{ item.formControlValue }}
                        </span>
                    </li>
                </ul>
            </div>
        </ng-template>
    </div>
</section>
